<nav class="navbar navbar-expand navbar-light bg-light capitan-sub-nav bg-sub-nav-2 pl-md-5"
     *ngIf="!loadingOrganizationConfig && serverError === null">
  <ul class="navbar-nav"></ul>

  <ul class="navbar-nav mx-auto">
    <li class="nav-item">
      <a class="nav-link" href="#"
         (click)="scrollToElement('profile-grid');$event.preventDefault();"
         [class.active]="currentSectionId === 'profile-grid'">
        Profile Grid
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link" href="#"
         (click)="scrollToElement('action-button-order');$event.preventDefault();"
         [class.active]="currentSectionId === 'action-button-order'">
        Action Button Order
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link" href="#"
         (click)="scrollToElement('sidebar-card-order');$event.preventDefault();"
         [class.active]="currentSectionId === 'sidebar-card-order'">
        Sidebar Card Order
      </a>
    </li>
  </ul>

  <form class="form-inline">
    <button class="btn btn-outline-primary btn-sm"
            type="button" (click)="openPreview()"
            [disabled]="loadingOrganizationConfig">
      Preview
    </button>
    <button class="btn btn-primary btn-sm ml-2"
            [class.disabled]="savingOrganizationConfig" [disabled]="savingOrganizationConfig"
            type="button" (click)="saveOrganizationConfig()">
      {{ savingOrganizationConfig ? 'Saving...' : 'Save' }}
    </button>
  </form>
</nav>

<div class="pt-3" *ngIf="loadingOrganizationConfig">
  <h2>Loading...</h2>
</div>

<div class="pt-3" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="capitan-sub-nav-post-content" appScrollDetect
     *ngIf="!loadingOrganizationConfig && (serverError === null)">
<div class="pl-md-4 pt-4 mb-7">
  <div class="floating-alert-container">
    <div class="alert alert-success alert-dismissible" role="alert" *ngIf="successMessage">
      {{ successMessage }}
      <button type="button" class="close" (click)="successMessage = ''">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  </div>

  <h2 class="mb-3">Configure Customer Profile Layout</h2>

  <div appScrollSpy [spiedTags]="['H3']" (sectionChange)="onSectionChange($event)">

  <h3 id="profile-grid">Profile Grid</h3>
  <div class="row">
    <div class="col-lg-8">
      <p>
        Below you can configure what information is displayed on each customer profile. This only impacts what is shown; it does not impact what data is stored and collected.
      </p>
    </div>
  </div>

  <div class="row">
    <div class="col-lg-8">
      <div class="row">
        <div class="col-4 pr-0">
          <div class="rounded-border rounded-tight p-2" style="height: 300px">
            <img src="/assets/images/photo_placeholder.png"
                 class="customer-photo my-2">
            <p class="customer-name">Full Name</p>
            <select class="form-control form-control-sm mt-1" style="width: 60%;margin-left: 20%;"
                    [(ngModel)]="organizationConfig.profile_contact_field"
                    (ngModelChange)="unsavedChanges = true">
              <option [value]="ProfileField.email">Email</option>
              <option [value]="ProfileField.telephone">Phone Number</option>
            </select>
            <div class="row mt-3">
              <div class="col pr-1">
                <select class="form-control form-control-sm"
                        [(ngModel)]="organizationConfig.major_profile_field_1"
                        (ngModelChange)="unsavedChanges = true">
                  <option *ngFor="let configOption of CONFIG_OPTIONS" [value]="configOption">
                    {{ getThisCustomerFieldLabel(configOption) }}
                  </option>
                  <ng-container *ngIf="customCustomerFields">
                    <option *ngFor="let ccf of customCustomerFields"
                            [value]="ProfileField.customCustomerField + ccf.id.toString()">
                      {{ ccf.name }}
                    </option>
                  </ng-container>
                </select>
              </div>
              <div class="col pl-1">
                <select class="form-control form-control-sm"
                        [(ngModel)]="organizationConfig.major_profile_field_2"
                        (ngModelChange)="unsavedChanges = true">
                  <option *ngFor="let configOption of CONFIG_OPTIONS" [value]="configOption">
                    {{ getThisCustomerFieldLabel(configOption) }}
                  </option>
                  <ng-container *ngIf="customCustomerFields">
                    <option *ngFor="let ccf of customCustomerFields"
                            [value]="ProfileField.customCustomerField + ccf.id.toString()">
                      {{ ccf.name }}
                    </option>
                  </ng-container>
                </select>
              </div>
            </div>
            <div class="form-text text-danger d-block">{{ errors.profile_contact_field }}</div>
            <div class="form-text text-danger d-block">{{ errors.major_profile_field_1 }}</div>
            <div class="form-text text-danger d-block">{{ errors.major_profile_field_2 }}</div>
          </div>
        </div>
        <div class="col-8">
          <div class="rounded-border rounded-tight p-2 pt-5" style="height: 300px">
            <div class="row mb-4">
              <div class="col pr-1">
                <select class="form-control form-control-sm"
                        [(ngModel)]="organizationConfig.minor_profile_field_1"
                        (ngModelChange)="unsavedChanges = true">
                  <option *ngFor="let configOption of CONFIG_OPTIONS" [value]="configOption">
                    {{ getThisCustomerFieldLabel(configOption) }}
                  </option>
                  <ng-container *ngIf="customCustomerFields">
                    <option *ngFor="let ccf of customCustomerFields"
                            [value]="ProfileField.customCustomerField + ccf.id.toString()">
                      {{ ccf.name }}
                    </option>
                  </ng-container>
                </select>
              </div>
              <div class="col px-1">
                <select class="form-control form-control-sm"
                        [(ngModel)]="organizationConfig.minor_profile_field_2"
                        (ngModelChange)="unsavedChanges = true">
                  <option *ngFor="let configOption of CONFIG_OPTIONS" [value]="configOption">
                    {{ getThisCustomerFieldLabel(configOption) }}
                  </option>
                  <ng-container *ngIf="customCustomerFields">
                    <option *ngFor="let ccf of customCustomerFields"
                            [value]="ProfileField.customCustomerField + ccf.id.toString()">
                      {{ ccf.name }}
                    </option>
                  </ng-container>
                </select>
              </div>
              <div class="col pl-1">
                <select class="form-control form-control-sm"
                        [(ngModel)]="organizationConfig.minor_profile_field_3"
                        (ngModelChange)="unsavedChanges = true">
                  <option *ngFor="let configOption of CONFIG_OPTIONS" [value]="configOption">
                    {{ getThisCustomerFieldLabel(configOption) }}
                  </option>
                  <ng-container *ngIf="customCustomerFields">
                    <option *ngFor="let ccf of customCustomerFields"
                            [value]="ProfileField.customCustomerField + ccf.id.toString()">
                      {{ ccf.name }}
                    </option>
                  </ng-container>
                </select>
              </div>
            </div>
            <div class="form-text text-danger d-block">{{ errors.minor_profile_field_1 }}</div>
            <div class="form-text text-danger d-block">{{ errors.minor_profile_field_2 }}</div>
            <div class="form-text text-danger d-block">{{ errors.minor_profile_field_3 }}</div>
            <div class="row mb-4">
              <div class="col pr-1">
                <select class="form-control form-control-sm"
                        [(ngModel)]="organizationConfig.minor_profile_field_4"
                        (ngModelChange)="unsavedChanges = true">
                  <option *ngFor="let configOption of CONFIG_OPTIONS" [value]="configOption">
                    {{ getThisCustomerFieldLabel(configOption) }}
                  </option>
                  <ng-container *ngIf="customCustomerFields">
                    <option *ngFor="let ccf of customCustomerFields"
                            [value]="ProfileField.customCustomerField + ccf.id.toString()">
                      {{ ccf.name }}
                    </option>
                  </ng-container>
                </select>
              </div>
              <div class="col px-1">
                <select class="form-control form-control-sm"
                        [(ngModel)]="organizationConfig.minor_profile_field_5"
                        (ngModelChange)="unsavedChanges = true">
                  <option *ngFor="let configOption of CONFIG_OPTIONS" [value]="configOption">
                    {{ getThisCustomerFieldLabel(configOption) }}
                  </option>
                  <ng-container *ngIf="customCustomerFields">
                    <option *ngFor="let ccf of customCustomerFields"
                            [value]="ProfileField.customCustomerField + ccf.id.toString()">
                      {{ ccf.name }}
                    </option>
                  </ng-container>
                </select>
              </div>
              <div class="col pl-1">
                <select class="form-control form-control-sm"
                        [(ngModel)]="organizationConfig.minor_profile_field_6"
                        (ngModelChange)="unsavedChanges = true">
                  <option *ngFor="let configOption of CONFIG_OPTIONS" [value]="configOption">
                    {{ getThisCustomerFieldLabel(configOption) }}
                  </option>
                  <ng-container *ngIf="customCustomerFields">
                    <option *ngFor="let ccf of customCustomerFields"
                            [value]="ProfileField.customCustomerField + ccf.id.toString()">
                      {{ ccf.name }}
                    </option>
                  </ng-container>
                </select>
              </div>
            </div>
            <div class="form-text text-danger d-block">{{ errors.minor_profile_field_4 }}</div>
            <div class="form-text text-danger d-block">{{ errors.minor_profile_field_5 }}</div>
            <div class="form-text text-danger d-block">{{ errors.minor_profile_field_6 }}</div>
            <div class="row">
              <div class="col pr-1">
                <select class="form-control form-control-sm"
                        [(ngModel)]="organizationConfig.minor_profile_field_7"
                        (ngModelChange)="unsavedChanges = true">
                  <option *ngFor="let configOption of CONFIG_OPTIONS" [value]="configOption">
                    {{ getThisCustomerFieldLabel(configOption) }}
                  </option>
                  <ng-container *ngIf="customCustomerFields">
                    <option *ngFor="let ccf of customCustomerFields"
                            [value]="ProfileField.customCustomerField + ccf.id.toString()">
                      {{ ccf.name }}
                    </option>
                  </ng-container>
                </select>
              </div>
              <div class="col px-1">
                <select class="form-control form-control-sm"
                        [(ngModel)]="organizationConfig.minor_profile_field_8"
                        (ngModelChange)="unsavedChanges = true">
                  <option *ngFor="let configOption of CONFIG_OPTIONS" [value]="configOption">
                    {{ getThisCustomerFieldLabel(configOption) }}
                  </option>
                  <ng-container *ngIf="customCustomerFields">
                    <option *ngFor="let ccf of customCustomerFields"
                            [value]="ProfileField.customCustomerField + ccf.id.toString()">
                      {{ ccf.name }}
                    </option>
                  </ng-container>
                </select>
              </div>
              <div class="col pl-1">
                <select class="form-control form-control-sm"
                        [(ngModel)]="organizationConfig.minor_profile_field_9"
                        (ngModelChange)="unsavedChanges = true">
                  <option *ngFor="let configOption of CONFIG_OPTIONS" [value]="configOption">
                    {{ getThisCustomerFieldLabel(configOption) }}
                  </option>
                  <ng-container *ngIf="customCustomerFields">
                    <option *ngFor="let ccf of customCustomerFields"
                            [value]="ProfileField.customCustomerField + ccf.id.toString()">
                      {{ ccf.name }}
                    </option>
                  </ng-container>
                </select>
              </div>
            </div>
            <div class="form-text text-danger d-block">{{ errors.minor_profile_field_7 }}</div>
            <div class="form-text text-danger d-block">{{ errors.minor_profile_field_8 }}</div>
            <div class="form-text text-danger d-block">{{ errors.minor_profile_field_9 }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <h3 id="action-button-order" class="pt-4">Action Button Order</h3>
  <div class="row">
    <div class="col-lg-8">
      <p>
        Drag to reorder the action buttons shown at the top of each customer profile. As many
        as fit are shown directly; the rest collapse into a &ldquo;More&rdquo; dropdown, so the
        order controls which actions stay directly clickable.
      </p>
    </div>
  </div>

  <div class="row">
    <div class="col-lg-6">
      <div cdkDropList (cdkDropListDropped)="dropActionButton($event)">
        <div class="rounded-border rounded-tight p-2 mb-2 d-flex align-items-center bg-white"
             *ngFor="let button of actionButtonOrder" cdkDrag style="cursor: move;">
          <span class="mr-3 text-muted" style="font-size: 18px; line-height: 1;">&#8801;</span>
          {{ getCustomerProfileActionButtonLabel(button) }}
        </div>
      </div>
    </div>
  </div>

  <h3 id="sidebar-card-order" class="pt-4">Sidebar Card Order</h3>
  <div class="row">
    <div class="col-lg-8">
      <p>Drag to reorder the cards that appear in the right-hand sidebar of each customer profile.</p>
    </div>
  </div>

  <div class="row">
    <div class="col-lg-6">
      <div cdkDropList (cdkDropListDropped)="dropSidebarCard($event)">
        <div class="rounded-border rounded-tight p-2 mb-2 d-flex align-items-center bg-white"
             *ngFor="let card of sidebarOrder" cdkDrag style="cursor: move;">
          <span class="mr-3 text-muted" style="font-size: 18px; line-height: 1;">&#8801;</span>
          {{ getCustomerProfileSidebarCardLabel(card) }}
        </div>
      </div>
    </div>
  </div>

  </div>
</div>
</div>
